import { IXHRClient } from './xhr-client.interface';

export abstract class XHRClient implements IXHRClient {
  protected xhr = new XMLHttpRequest();

  private _setHeaders(): void {
    this.xhr.setRequestHeader('Content-Type', 'application/json');
    this.setHeaders();
  }

  protected abstract setHeaders(): void;

  post<T>(url: string, data?: { [value: string]: any }): Promise<T> {
    return new Promise((succeed, fail) => {
      this.xhr.open('POST', url, true);
      this._setHeaders();
      this.xhr.addEventListener('load', () => {
        if (this.xhr.status < 400) {
          succeed(JSON.parse(this.xhr.response) as T);
        } else {
          fail(new Error('Request failed: ' + this.xhr.statusText));
        }
      });
      this.xhr.addEventListener('error', () => {
        fail(new Error('Network error'));
      });

      const dataString = data ? JSON.stringify(data) : undefined;
      this.xhr.send(dataString);
    });
  }

  get<T>(url: string, queryParams?: { [value: string]: any }): Promise<T> {
    const trimParam = (val: string) => {
      return val.replace(/^'+|'+$/g, '');
    };

    return new Promise((succeed, fail) => {
      const params = queryParams
        ? '?' +
          Object.keys(queryParams)
            .map(key => {
              return `${key}=${encodeURIComponent(trimParam(JSON.stringify(queryParams[key])))}`;
            })
            .join('&')
        : '';

      this.xhr.open('GET', url + params, true);
      this._setHeaders();
      this.xhr.addEventListener('load', () => {
        if (this.xhr.status < 400) {
          succeed(JSON.parse(this.xhr.response) as T);
        } else {
          fail(new Error('Request failed: ' + this.xhr.statusText));
        }
      });
      this.xhr.addEventListener('error', () => {
        fail(new Error('Network error'));
      });
      this.xhr.send();
    });
  }
}
